/** The three twin dialogs, driven by useTwinUi.dialog; mounted once by the Shell. */
import { HealthDashboard } from './HealthDashboard';
import { MaintenanceHistoryDialog } from './MaintenanceHistory';
import { SystemReportDialog } from './SystemReportDialog';
import { useTwin } from '../../store';
import { isRfims } from '@/features/rfims/registry';

export function TwinDialogs() {
  const assetId = useTwin(s => s.assetId);
  if (isRfims(assetId)) return null;
  return (
    <>
      <SystemReportDialog />
      <HealthDashboard />
      <MaintenanceHistoryDialog />
    </>
  );
}
